import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import menuSchema from "./menu-schema";
import Menu from "layouts/common/menu";
import FacebookIcon from "themes/cashrent/assets/svg/facebook.svg";
import { t1 } from "i18n";
import { isPartnerSite } from "utils";
import { GetSiteConfigs } from "../../../../hooks/useChangeGlobalStyles";
import "./CashrentFooter.scss";

const CashrentFooter = () => {
  const SiteConfigs = GetSiteConfigs() || null;
  const [windowInnerWidth, setWindowInnerWidth] = useState(window.innerWidth);
  const mode = windowInnerWidth < 1000 ? "vertical" : "horizontal";
  const updateWindowDimensions = () => {
    setWindowInnerWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", updateWindowDimensions);

    return () => {
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []);

  return (
    <div
      className={"ui-theme-footer footer-cashrent"}
      style={{ marginBottom: "-22px" }}
    >
      <div className="content-panel">
        <div className="ui-logo item">
          <Link to={"/"}>
            <img src={SiteConfigs?.logo?.src} />
          </Link>
        </div>
        <div className="ui-menu-panel item">
          <Menu
            mode={mode}
            onClick={() => {
              const nodes =
                document.getElementsByClassName("ant-back-top-inner");
              if (nodes && nodes.length > 0) {
                nodes[0].click();
              }
            }}
            className="ui-top-menu-detail"
            style={{ lineHeight: "35px" }}
            schema={menuSchema && menuSchema()}
          />
        </div>
        <div className="item text-color">{t1("Stay in touch")}</div>
        <div className="item">
          {/* <a href={''} className={'m-r-10 social'} target='_blank'>
              <img src={Twitter}/>
            </a> */}
          <a
            href={"https://www.facebook.com/cashrentfarmland"}
            className={"social"}
            target="_blank"
          >
            <img src={FacebookIcon} />
          </a>
        </div>
        <div className="item text-color">
          {!isPartnerSite()
            ? `© ${new Date().getFullYear()} Cashrent. All rights reserved`
            : "Powered by commonground.io"}
        </div>
      </div>
    </div>
  );
};

export default CashrentFooter;
